import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useExamStatus } from "./ExamStatusContext";
import { useToken } from "../TokenContext";
import Test1 from "./test/Test3";
import Test2 from "./test/Test4";
import Test3 from "./test/Test5";
import Test4 from "./test/Test6";
import Test5 from "./test/Test7";
import Test6 from "./test/Test8";
import Test7 from "./test/Test9";
import Test8 from "./test/Test10";
import Test9 from "./test/Test11";

const GATBtest = () => {
  const [step, setStep] = useState(1); // 最初の検査から開始
  const { examStatus, setExamStatus } = useExamStatus();
  const navigate = useNavigate();

  useEffect(() => {
    if (examStatus === "検査前") {
      setExamStatus("検査中");
    }
  }, []);

  const handleNext = () => {
    if (step < 9) {
      setStep((prev) => prev + 1);
    } else {
      navigate("/GATBresult");
    }
  };

  const renderStep = () => {
    switch (step) {
      case 1: return <Test1 onNext={handleNext} />;
      case 2: return <Test2 onNext={handleNext} />;
      case 3: return <Test3 onNext={handleNext} />;
      case 4: return <Test4 onNext={handleNext} />;
      case 5: return <Test5 onNext={handleNext} />;
      case 6: return <Test6 onNext={handleNext} />;
      case 7: return <Test7 onNext={handleNext} />;
      case 8: return <Test8 onNext={handleNext} />;
      case 9: return <Test9 onNext={handleNext} />;
      default: return <p>不明なステップです。</p>;
    }
  };

  return <div>{renderStep()}</div>;
};

export default GATBtest;
